var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"home"},[_c('Navbar'),_c('Users')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }